module.exports = __webpack_public_path__ + "img/block_bg_6.b8cd46ef.png";